import React from "react";

// Piezas comunes de la sección «Reportes» de supervisoras (menú, diario, residentes y sustituciones)
export const COLOR = { diario: "#2563eb", residentes: "#7c3aed", sustituciones: "#0d9488", hoy: "#dc2626", retr: "#ea580c", ok: "#16a34a" };

export const fechaLarga = (iso) => {
  try {
    const t = new Date(iso + "T12:00:00").toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "long" });
    return t.charAt(0).toUpperCase() + t.slice(1);
  } catch (_) { return iso; }
};

// Chips con el número de pendientes: rojo = de hoy, naranja = retrasados, verde = al día
export const ChipsPendientes = ({ hoy = 0, retr = 0, grande = false }) => {
  const base = { display: "inline-flex", alignItems: "center", gap: 6, borderRadius: 999, fontWeight: 800, whiteSpace: "nowrap", padding: grande ? "7px 14px" : "4px 11px", fontSize: grande ? 15 : 13 };
  if (!hoy && !retr) return <span style={{ ...base, background: "#dcfce7", color: "#15803d", border: "1px solid #86efac" }}>✅ Al día</span>;
  return (
    <span style={{ display: "inline-flex", gap: 6, flexWrap: "wrap", justifyContent: "center" }}>
      {hoy > 0 && <span style={{ ...base, background: COLOR.hoy, color: "#fff" }}>🔴 {hoy} {hoy === 1 ? "pendiente hoy" : "pendientes hoy"}</span>}
      {retr > 0 && <span style={{ ...base, background: "#ffedd5", color: "#c2410c", border: "1px solid #fdba74" }}>⏰ {retr} {retr === 1 ? "retrasado" : "retrasados"}</span>}
    </span>
  );
};

export const Cabecera = ({ titulo, emoji, color, onVolver, children }) => (
  <div style={{ marginBottom: 18 }}>
    <button onClick={onVolver} style={st.volver}>← Volver</button>
    <div style={{ textAlign: "center", marginTop: 10 }}>
      <div style={{ fontSize: 44, lineHeight: 1 }}>{emoji}</div>
      <h1 style={{ fontSize: 26, fontWeight: 900, color, margin: "6px 0 10px" }}>{titulo}</h1>
      {children}
    </div>
  </div>
);

// Título de sección con contador
export const Seccion = ({ emoji, titulo, n, color, children, vacio }) => (
  <section style={{ marginTop: 22 }}>
    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
      <span style={{ fontSize: 22 }}>{emoji}</span>
      <h2 style={{ fontSize: 19, fontWeight: 900, color: "#1e293b", margin: 0, flex: 1 }}>{titulo}</h2>
      {n > 0 && <span style={{ background: color, color: "#fff", borderRadius: 999, padding: "3px 12px", fontWeight: 900, fontSize: 15 }}>{n}</span>}
    </div>
    {n === 0 && vacio && <div style={{ ...st.vacio, marginBottom: 10 }}>{vacio}</div>}
    {children}
  </section>
);

export const Pagina = ({ children }) => (
  <div style={{ maxWidth: 560, margin: "0 auto", padding: "16px 16px 60px", fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", boxSizing: "border-box" }}>{children}</div>
);

export const st = {
  volver: { padding: "10px 22px", borderRadius: 20, background: "linear-gradient(135deg, #3b82f6, #1d4ed8)", color: "#fff", border: "none", cursor: "pointer", fontWeight: 700, fontSize: 15, boxShadow: "0 2px 8px rgba(29,78,216,0.35)" },
  vacio: { background: "#f0fdf4", border: "1.5px dashed #86efac", color: "#15803d", borderRadius: 16, padding: "18px", textAlign: "center", fontWeight: 700, fontSize: 16 },
  tarjeta: { display: "flex", alignItems: "center", gap: 12, width: "100%", boxSizing: "border-box", padding: "14px 16px", borderRadius: 18, border: "2px solid", background: "#fff", marginBottom: 10, textAlign: "left", fontFamily: "inherit", boxShadow: "0 2px 10px rgba(15,23,42,0.07)" },
  abrev: { fontSize: 20, fontWeight: 900, color: "#1e3a5f" },
  boton: { border: "none", borderRadius: 12, padding: "10px 16px", fontWeight: 800, fontSize: 15, color: "#fff", cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" },
};
